import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeContextProvider } from './contexts/ThemeContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import NotFoundPage from './pages/NotFoundPage';
import DashboardPage from './pages/DashboardPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AppsPage from './pages/AppsPage';
import LogsPage from './pages/LogsPage';
import OperationsPage from './pages/OperationsPage';
import AccessDeniedPage from './pages/AccessDeniedPage';
import PricingPage from './pages/PricingPage';
import AnalyticsPage from './pages/AnalyticsPage';
import DocsPage from './pages/DocsPage';
import RequestsPage from './pages/RequestsPage';
import ChangelogsPage from './pages/ChangelogsPage';
import AssistantPage from './pages/AssistantPage';
import StatusPage from './pages/StatusPage';
import AssistantConfigPage from './pages/AssistantConfigPage';
import ProfilePage from './pages/ProfilePage';

function App() {
  return (
    <ThemeContextProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public pages */}
            <Route path="/home" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/access-denied" element={<AccessDeniedPage />} />
            <Route path="/docs" element={<DocsPage />} />

            {/* App shell — auth bypass active, no PrivateRoute needed */}
            <Route path="/" element={<Layout />}>
              <Route index element={<DashboardPage />} />
              <Route path="apps" element={<AppsPage />} />
              <Route path="apps/:appId" element={<AppsPage />} />
              <Route path="apps/:appId/edit" element={<AppsPage />} />
              <Route path="users" element={<AdminUsersPage />} />
              <Route path="logs" element={<LogsPage />} />
              <Route path="operations" element={<OperationsPage />} />
              <Route path="pricing"    element={<PricingPage />} />
              <Route path="analytics"  element={<AnalyticsPage />} />
              <Route path="analytics/:appId" element={<AnalyticsPage />} />
              <Route path="requests"   element={<RequestsPage />} />
              <Route path="requests/:requestId" element={<RequestsPage />} />
              <Route path="changelogs" element={<ChangelogsPage />} />
              <Route path="assistant" element={<AssistantPage />} />
              <Route path="assistant/config" element={<AssistantConfigPage />} />
              <Route path="status" element={<StatusPage />} />
              <Route path="profile" element={<ProfilePage />} />
            </Route>

            {/* 404 */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeContextProvider>
  );
}

export default App;
